export default __webpack_public_path__ + "static/media/RippleMaker.96e30d75.png";